import { computed, Directive, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';
import { cva, type VariantProps } from 'class-variance-authority';

import type { ClassValue } from 'clsx';

export const alertVariants = cva(
    'tw-relative tw-w-full tw-rounded-lg tw-border [&>[hlmAlertIcon]]:tw-absolute',
    {
        variants: {
            variant: {
                default: 'tw-bg-accent tw-text-foreground tw-border-border [&>[hlmAlertIcon]]:tw-text-foreground',
                warning:
                    'tw-bg-amber-50 tw-text-amber-600 tw-border-amber-100 dark:tw-border-amber-600 [&>[hlmAlertIcon]]:tw-text-amber-600',
                destructive:
                    'tw-bg-destructive/10 tw-text-destructive tw-border-none dark:tw-border-destructive [&>[hlmAlertIcon]]:tw-text-destructive',
                info:
                    'tw-bg-sky-600/10 tw-text-sky-600 tw-border-none dark:tw-border-sky-600 [&>[hlmAlertIcon]]:tw-text-sky-600 tw-text-sky-600'
            },
            size: {
                sm: 'tw-text-xs tw-p-2 [&>[hlmAlertIcon]]:tw-left-2 [&>[hlmAlertIcon]]:tw-top-2 [&>[hlmAlertIcon]+div]:tw-translate-y-[-1px] [&>[hlmAlertIcon]~*]:tw-pl-6',
                md: 'tw-py-3 tw-px-4 [&>[hlmAlertIcon]]:tw-left-4 [&>[hlmAlertIcon]]:tw-top-4 [&>[hlmAlertIcon]+div]:tw-translate-y-[-3px] [&>[hlmAlertIcon]~*]:tw-pl-8'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'md'
        }
    }
);
export type AlertVariants = VariantProps<typeof alertVariants>;

@Directive({
    selector: '[hlmAlert]',
    standalone: true,
    host: {
        role: 'alert',
        '[class]': '_computedClass()'
    }
})
export class HlmAlertDirective {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    public readonly variant = input<AlertVariants['variant']>('default');
    public readonly size = input<AlertVariants['size']>('md');

    protected readonly _computedClass = computed(() => sonaHlm(alertVariants({
        variant: this.variant(),
        size: this.size()
    }), this.userClass()));
}
